import { render, staticRenderFns } from "./ifp-picker.vue?vue&type=template&id=0bd0f6bb&"
import script from "./ifp-picker.vue?vue&type=script&lang=ts&"
export * from "./ifp-picker.vue?vue&type=script&lang=ts&"
import style0 from "./ifp-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports